import { FormGroup, FormBuilder } from "@angular/forms";

import {
  Component,
  OnInit,
  AfterContentInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Empreiteira } from "src/app/models/empreiteira.model";
import { EncarregadoCB } from "src/app/models/encarregadoCB.model";
import { Funcionario } from "src/app/models/funcionario.model";
import { OS } from "src/app/models/os.model";
import { SpvParaOS } from "src/app/models/spv-para-OS-model";
import { AreaTecnicaService } from "src/app/pages/cadastros/areatecnica/areatecnica.service";
import { EmpreiteiraService } from "src/app/pages/cadastros/empreiteira/empreiteira.service";
import { LocalService } from "src/app/services/local.service";
import { OSService } from "src/app/services/os-service";
import { SpvService } from "src/app/services/spv.service";
import { SCAMP_API_RPT, APP_SETTINGS } from "src/environments/environment";
import { FuncionarioService } from "src/app/pages/cadastros/funcionario/funcionario.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { CommandResult } from "../../domain/commandResult";
import { OSTipoViewModel } from "../../domain/viewmodels.models";

@Component({
  selector: "app-emitir-os",
  templateUrl: "./emitir-os.component.html",
  styleUrls: ["./emitir-os.component.scss"],
  providers: [
    LocalService,
    AreaTecnicaService,
    OSService,
    EmpreiteiraService,
    SpvService,
    FuncionarioService,
  ],
})
export class EmitirOSComponent implements OnInit, AfterContentInit {
  constructor(
    private toastr: ToastrService,
    private activatedRouter: ActivatedRoute,
    private modalService: NgbModal,
    private osService: OSService,
    private empreiteiraService: EmpreiteiraService,
    private spvService: SpvService,
    private funcionarioService: FuncionarioService,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder
  ) {}

  isNovoCadastro = true;
  isSalvando = false;

  spvs: SpvParaOS[] = undefined;
  empreiteiras: Empreiteira[] = [];
  engenheiros: Funcionario[] = [];
  OSs: OS[] = [];
  spvsComOS: SpvParaOS[] = [];
  totalSpvsSelecionados = 0;
  validacaoEncarregado = "";
  funcionarios: Funcionario[] = [];
  funcionariosSelecionados: Funcionario[] = [];
  encarregados: EncarregadoCB[] = [];
  validado = false;
  spvCompleto: any = null; // representa SS ou PT
  autorizacoes: UsuarioAutorizacoes;

  imprimindoOS: boolean = false;
  imprimindoOSId: number = 0;
  isProcessing:boolean = false;

  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  @ViewChild("obterosmanual") obterosmanual: ElementRef;
  @ViewChild("imprimirEvidenciaDeFotos") imprimirEvidenciaDeFotos: ElementRef;

  form: FormGroup = this.formBuilder.group({
    empreiteiraId: [""],
    encarregadoResponsavelId: [""],
    tipoProgramacao: ["1"]
  });

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("emitir-os");
  }

  ngOnInit() {
    this.empreiteiraService.getEmpreiteiras().subscribe((response) => {
      this.empreiteiras = response;
      if (this.empreiteiras.length === 1) {
        this.form.controls.empreiteiraId.setValue(this.empreiteiras[0].id);
        this.getEncarregadosPorEmpreiteira(this.empreiteiras[0].id);
      }
    });

    const param = this.activatedRouter.snapshot.params.id;
    this.isNovoCadastro = param === undefined || param === "";
  }

  setValidado() {
    this.validado = this.totalSpvsSelecionados > 0;
  }

  getEncarregadosPorEmpreiteira(id: number) {
    if (Number(id) === 0) {
      this.encarregados = [];
      return;
    }
    this.funcionarioService
      .getEncarregadosPorEmpreiteira(id)
      .subscribe((response) => {
        this.encarregados = response;
        if (this.spvs) {
          if (this.spvs.length > 0) {
            this.buscar(true);
          }
        }
      });
  }

  changeParams() {
    if (this.validarEncarregado()) {
      this.buscar(true);
    }
  }

  confirmarCadastro(modal) {
    if (this.validarEncarregado()) {
      this.modalService.open(modal, {
        windowClass: "smModal",
        backdrop: "static",
      });
    }
  }

  validarEncarregado() {
    this.validacaoEncarregado = "";
    if (this.form.get("encarregadoResponsavelId").value == "") {
      this.validacaoEncarregado = "Selecione um responsável OS";
      return false;
    }

    return true;
  }

  submit() {
    if (this.validarEncarregado()) {
      this.isSalvando = true;

      // levantar quais candidatas a OS já tem Id criado
      let PTIds = this.OSs.filter((t) => t.pTId != null)
        .map((t) => t.pTId)
        .toString();
      let SpvAprovadosIds = this.OSs.filter((t) => t.spvAprovadoId != null)
        .map((t) => t.spvAprovadoId)
        .toString();
      let Ids = "";
      this.spvsComOS = [];

      if (PTIds && SpvAprovadosIds) {
        Ids = PTIds + ", " + SpvAprovadosIds;
      } else {
        if (PTIds) {
          Ids = PTIds;
        }
        if (SpvAprovadosIds) {
          Ids = SpvAprovadosIds;
        }
      }

      this.osService.getOSsPorPTIdOuSpvAprovadoId(Ids).subscribe((res) => {
        if (res.length > 0) {
          this.spvsComOS = this.spvs.filter((t) =>
            res.find(
              (r) => r.spvAprovadoId == t.spvAprovadoId || r.ptId == t.ptId
            )
          );

          let seq = 0;
          this.spvsComOS.forEach((spv) => {
            spv.osId = res[seq].osId;
            seq++;
          });

          this.OSs = this.OSs.filter(
            (t) =>
              !res.find(
                (r) => r.spvAprovadoId == t.spvAprovadoId || r.ptId == t.pTId
              )
          );
        }

        //submit
        if (this.OSs.length > 0) {
          this.osService.gerarOSs(this.OSs).subscribe(
            (retorno: any) => {
              let OSsTipo: OSTipoViewModel[] = [];

              if (
                (this.obterosmanual.nativeElement.checked as boolean) == true
              ) {
                retorno.data.forEach((d) => {
                  OSsTipo.push({
                    oSId: d.id,
                    tipoOSFilha: d.tipoOSFilha,
                    fileNamePdf: "",
                    imprimirEvidenciaDeFotos: this.imprimirEvidenciaDeFotos
                      .nativeElement.checked
                      ? "S"
                      : "N",
                  });
                });

                this.osService.imprimirOSMerge(OSsTipo).subscribe(
                  (response) => {
                    if (response.success === true) {
                      if (response.nenhumResultado === false) {
                        window.open(
                          `${SCAMP_API_RPT.root}${response.pathRpt}`,
                          "_blank",
                          "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no"
                        );
                      } else {
                        this.toastr.warning(response.msgErro);
                      }
                    } else {
                      this.toastr.error(response.msgErro);
                    }
                  },
                  (err: any) => {
                    this.toastr.error(
                      "Não foi possível se conectar ao servidor de relatórios",
                      "Erro de Conexão"
                    );
                  }
                );
              }
              let msg = "<b>OSs</b> geradas";

              if (this.OSs.length === 1) {
                msg = "<b>OS</b> gerada";
              }

              let msgPdf = "";

              if (
                (this.obterosmanual.nativeElement.checked as boolean) == true
              ) {
                msgPdf = "<br />Aguarde... PDF(s) sendo gerado(s)";
              }

              this.toastr.success(`${msg} com sucesso${msgPdf}`);

              this.reset();

              this.buscar(false);
              this.isSalvando = false;
            },
            (err) => {
              if (err.error.errors) {
                this.toastr.error(err.error.errors[0].message);
              } else {
                this.toastr.error("Ocorreu um erro no servidor");
              }
              this.isSalvando = false;
            }
          );
        } else {
          this.reset();

          this.buscar(false);
          this.isSalvando = false;
        }
      });
    } else {
      console.log("Encarregados não validado");
    }
  }

  reset() {
    this.isSalvando = false;
    this.isNovoCadastro = true;
    this.OSs = [];
    //this.spvsComOS = [];
    this.totalSpvsSelecionados = 0;
    this.validacaoEncarregado = "";
    this.isProcessing = false;

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  clearSpvsComOS() {
    this.spvsComOS = [];
  }
  buscar(chamadaExterna: boolean) {
    this.isProcessing = true;
    this.totalSpvsSelecionados = 0;
    this.OSs = [];
    //this.spvsComOS = [];
    const empreiteiraId = this.form.controls.empreiteiraId.value;
    const encarregadoResponsavelId = this.form.controls.encarregadoResponsavelId.value;
    const tipoProgramacao = this.form.controls.tipoProgramacao.value;
    

    this.osService
      .getSpvsParaOS(Number(empreiteiraId), Number(encarregadoResponsavelId), tipoProgramacao)
      .subscribe(
        (response) => {
          this.spvs = response;

          if (this.spvs.length === 0 && chamadaExterna === true) {
            this.toastr.warning("Nenhum resultado foi encontrado");
          }
          this.isProcessing = false;
        },
        (err: any) => {
          console.log(err);
          this.toastr.error(err.error.data.message);
          this.isProcessing = false;
        }
      );
  }

  selecionarSpv(spvId: number) {
    const spv = this.spvs.find((s) => s.spvId === spvId);

    if (spv !== undefined) {
      if (spv.marcado) {
        spv.marcado = false;
        this.OSs = this.OSs.filter((t) => t.spvId !== spvId);
      } else {
        spv.marcado = true;

        this.OSs.push(
          new OS(
            0,
            "R",
            spv.tipoOS,
            spv.requisitante,
            spv.servicoSolicitado,
            null,
            spv.ptId,
            spv.spvId,
            spv.spvAprovadoId,
            spv.tipoOSFilha,
            spv.empreiteiraId,
            spv.encarregadoResponsavelId,
            spv.engenheiroResponsavelId,
            spv.equipamentoId,
            null,
            null,
            null,
            spv.prioridadeId,
            spv.areaTecnicaId,
            this.form.controls.tipoProgramacao.value
          )
        );
      }

      this.totalSpvsSelecionados = this.OSs.length;
    }
  }

  selecionarTodos() {
    this.OSs = [];
    this.spvs.forEach((s) => (s.marcado = false));
    this.spvs.forEach((s) => this.selecionarSpv(s.spvId));
  }

  selecionarNenhum() {
    this.OSs = [];
    this.spvs.forEach((s) => (s.marcado = true));
    this.spvs.forEach((s) => this.selecionarSpv(s.spvId));
  }

  getById(spvId: number, tipoSpv: number, modalDetalhesSpv: any) {
    this.spvService.getSpvCompleto(spvId, tipoSpv).subscribe(
      (response) => {
        this.spvCompleto = response;
        this.modalService.open(modalDetalhesSpv, {
          windowClass: "lgModal",
          backdrop: "static",
        });
      },
      (err: any) => {
        this.toastr.error(
          `Ocorreu um erro no servidor.<br /><br /> ${err.error}`
        );
      }
    );
  }

  reimprimirOS(id: number, tipoOSFilha: number) {
    this.imprimindoOS = true;
    this.imprimindoOSId = id;

    this.osService
      .imprimirOS(
        id,
        tipoOSFilha,
        this.imprimirEvidenciaDeFotos.nativeElement.checked ? "S" : "N"
      )
      .subscribe(
        (response) => {
          if (response.success === true) {
            if (response.nenhumResultado === false) {
              window.open(
                `${SCAMP_API_RPT.root}${response.pathRpt}`,
                "_blank",
                "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no"
              );
            } else {
              this.toastr.warning(response.msgErro);
            }
          } else {
            this.toastr.error(response.msgErro);
          }
          this.imprimindoOS = false;
          this.imprimindoOSId = 0;
        },
        (err: any) => {
          this.toastr.error(
            "Não foi possível se conectar ao servidor de relatórios",
            "Erro de Conexão"
          );
          this.imprimindoOS = false;
          this.imprimindoOSId = 0;
        }
      );
  }
}
